import type { Socket } from "socket.io-client";
import { io } from "socket.io-client";

class SocketIOService {
  socket: Socket<any, any>;
  constructor() {
    this.socket = io(process.env.API_AI_BASE_URL ?? '');
  }
}

const socket = new SocketIOService().socket

socket.on('error', (error: any) => {
  console.log(error, 'socket error')
})

export { socket }
